import React from "react";

const AccountingAnalyticsTab = () => {
  return (
    <section className="bg-white border border-slate-100 rounded-xl shadow-sm p-6 space-y-3">
      <h2 className="text-lg font-semibold text-slate-900">Analytics</h2>
      <p className="text-sm text-slate-600">Visualize company cash flow trends to support budgeting and forecasting decisions.</p>
      <ul className="text-sm text-slate-700 list-disc list-inside space-y-1">
        <li>Compare inflows and outflows by period</li>
        <li>Highlight top expense and revenue categories</li>
        <li>Monitor net cash movement over time</li>
      </ul>
    </section>
  );
};

export default AccountingAnalyticsTab;
